var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5714 4.28572C2.11675 4.28572 1.68071 4.46633 1.35922 4.78782C1.03773 5.10931 0.857117 5.54535 0.857117 6.00001V21.4286C0.857117 21.8832 1.03773 22.3193 1.35922 22.6408C1.68071 22.9623 2.11675 23.1429 2.5714 23.1429H21.4285C21.8832 23.1429 22.3192 22.9623 22.6407 22.6408C22.9622 22.3193 23.1428 21.8832 23.1428 21.4286V6.00001C23.1428 5.54535 22.9622 5.10931 22.6407 4.78782C22.3192 4.46633 21.8832 4.28572 21.4285 4.28572H18",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    fillOpacity: 0,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.857117 11.1429H23.1428",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.857147V7.71429",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.857147V7.71429",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.28572H14.5714",
    stroke: "black",
    strokeOpacity: 0.52,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEmpty);
export default __webpack_public_path__ + "static/media/calendarEmpty.9ec8b2a637a248fcdd7bf407e26022dc.svg";
export { ForwardRef as ReactComponent };